import { RegistrationUrlParams } from "@models/auth";
import { getConfig } from "config";
import crypto from "crypto";
import { signIn, signOut } from "next-auth/react";
import { OAUTH_SCOPE } from "../constants/urls";

const { IDENTITY_BASE_URL, HOST } = getConfig();

const base64URLEncode = (buffer: Buffer) => {
	return buffer
		.toString("base64")
		.replace(/\+/g, "-")
		.replace(/\//g, "_")
		.replace(/=/g, "");
};

const sha256 = (value: string) => {
	return crypto.createHash("sha256").update(value).digest();
};

export const generateCodeVerifier = () => base64URLEncode(crypto.randomBytes(32));

export const generateCodeChallenge = (verifier: string) =>
	base64URLEncode(sha256(verifier));

export const getRegistrationUrl = ({
	clientId,
	redirectUri,
	codeChallenge,
	authServerUrl,
}: RegistrationUrlParams) => {
	const params = {
		client_id: clientId,
		redirect_uri: redirectUri,
		response_type: "code",
		code_challenge: codeChallenge,
		code_challenge_method: "S256",
		scope: OAUTH_SCOPE,
	};

	const urlParams = new URLSearchParams(params);
	return `${authServerUrl}?${urlParams.toString()}`;
};

export const login = async (currentUrl: string) => {
	// Use HOST as a dummy base to allow parsing relative URLs like "/cart?foo=bar"
	const url = new URL(currentUrl, HOST);
	const redirectPath = url.pathname;

	// This is the URL that the auth service will redirect back to.
	const handlerUrl = new URL(`${HOST}/account/redirect-handler`);
	handlerUrl.searchParams.set("callbackUrl", redirectPath);

	// Append all other params from the original URL to the handler URL.
	url.searchParams.forEach((value, key) => {
		handlerUrl.searchParams.append(key, value);
	});

	return await signIn("beatport", {
		callbackUrl: handlerUrl.toString(),
	});
};

export const logout = async () => {
	try {
		return await signOut({ redirect: false }); // Clear local NextAuth session
	} finally {
		// Ensure logout from IDS
		// Some browsers (like Safari/Firefox) block third-party cookies,
		// so this step is needed to fully clear the SSO session
		window.location.href = `${IDENTITY_BASE_URL}/identity/v1/logout/?callbackUrl=${HOST}`;
	}
};
